
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Punetopansharpurtaxi() {



  const cardData =
  {
    keyword: ' Pune to Pandharpur Taxi',
    heading: 'Vaishnavi Travels: Pune to Pandharpur Taxi',
    headingDescription: 'Vaishnavi Travels provides dependable and affordable Pune to Pandharpur Taxi service, specially designed for pilgrims, families, and group travelers. Our taxis are well-maintained with spacious seating, strong air-conditioning, and ample luggage space, ensuring a safe and comfortable ride on the Pune–Pandharpur route. With experienced chauffeurs, punctual pickups, and flexible booking options, we make religious journeys stress-free and convenient. Whether it’s a one-day darshan trip, weekend yatra, or group pilgrimage, Vaishnavi Travels guarantees reliable, comfortable, and hassle-free taxi services from Pune to Pandharpur.',

    top: 'Top Places to Visit in Pandharpur with Vaishnavi Travels',

"topPlaces": [
  {
    "title": "Vitthal Rukmini Mandir",
    "description": "Vitthal Rukmini Mandir is the heart of Pandharpur and one of Maharashtra’s most sacred pilgrimage sites. Dedicated to Lord Vitthal (a form of Lord Krishna) and Goddess Rukmini, it attracts millions of devotees, especially during Ashadhi and Kartiki Ekadashi yatras. The temple’s idol of Vitthal standing on a brick is iconic and deeply revered. Devotees wait hours for darshan, chanting abhangs with devotion. The temple is centuries old and rich in heritage. Vitthal Rukmini Mandir is Pandharpur’s divine soul."
  },
  {
    "title": "Chandrabhaga River (Bhima River)",
    "description": "The Chandrabhaga River, also called the Bhima River, flows gracefully around Pandharpur in the shape of a crescent moon. Pilgrims take holy dips in its waters before visiting the Vitthal temple, believing it purifies the soul. The ghats are filled with chanting, rituals, and festive energy during yatras. Evening aartis on the riverbank create a mesmerizing spiritual ambiance. It is also a peaceful spot for photography and meditation. Chandrabhaga is Pandharpur’s sacred lifeline."
  },
  {
    "title": "Pundalik Mandir",
    "description": "Pundalik Mandir honors the saint Pundalik, whose devotion is said to have brought Lord Vitthal to Pandharpur. It is believed Vitthal stood on a brick here when Pundalik offered him service. The temple has a simple structure but deep spiritual significance. Devotees visit after darshan at Vitthal Mandir to complete their pilgrimage. The temple stands as a reminder of seva (service) and bhakti (devotion). Pundalik Mandir is Pandharpur’s origin of divine presence."
  },
  {
    "title": "ISKCON Pandharpur",
    "description": "ISKCON Pandharpur, also known as Sri Sri Radha Pandharinath Temple, is a vibrant spiritual center run by the International Society for Krishna Consciousness. The temple is known for its lively kirtans, bhajans, and beautifully decorated deities. It offers guesthouses, prasadam, and cultural programs for devotees. The peaceful campus attracts international pilgrims too. Festivals like Janmashtami are celebrated grandly here. ISKCON is Pandharpur’s global center of Krishna devotion."
  },
  {
    "title": "Kaikadi Maharaj Math",
    "description": "Kaikadi Maharaj Math is a spiritual retreat and math dedicated to Saint Kaikadi Maharaj. It features life-size tableaux depicting stories from the Ramayana, Mahabharata, and Puranas. The displays make mythology engaging for children and pilgrims alike. The math also hosts religious discourses and satsangs. Its gardens and peaceful atmosphere add charm. Kaikadi Maharaj Math is Pandharpur’s cultural and devotional learning center."
  },
  {
    "title": "Sant Namdev Maharaj Mandir",
    "description": "Sant Namdev Maharaj Mandir honors the 13th-century saint and poet Namdev, a great devotee of Lord Vitthal. His abhangs are still sung by devotees during yatras. The temple is simple yet spiritually powerful, attracting bhaktas seeking inspiration. Pilgrims believe visiting this temple strengthens their connection with Vitthal. Namdev’s legacy lives on in Pandharpur’s devotional culture. This temple is Pandharpur’s tribute to bhakti saints."
  },
  {
    "title": "Sant Chokhamela Samadhi",
    "description": "Sant Chokhamela, a 14th-century saint from the Mahar community, is revered for his unwavering devotion to Vitthal despite social challenges. His samadhi near the Vitthal Mandir is visited by thousands of devotees daily. Pilgrims pay homage here as a symbol of equality and pure devotion. Bhajans dedicated to Chokhamela are sung during yatras. His story inspires faith beyond barriers. Sant Chokhamela Samadhi is Pandharpur’s shrine of devotion and humility."
  },
  {
    "title": "Vishnupad Temple",
    "description": "Vishnupad Temple is located on the banks of Chandrabhaga River and is believed to mark Lord Vishnu’s footprint. Devotees consider it a sacred spot for rituals and offerings. The temple is surrounded by calm ghats, making it a peaceful visit. Pilgrims often combine darshan here with bathing in the holy river. Its spiritual aura makes it important during yatras. Vishnupad is Pandharpur’s sacred mark of divinity."
  },
  {
    "title": "Sant Dynaneshwar Palkhi Stop",
    "description": "Pandharpur is the final destination of the Sant Dynaneshwar Palkhi Yatra that begins in Alandi. The palkhi procession covers hundreds of kilometers with lakhs of warkaris chanting abhangs and playing traditional instruments. The arrival in Pandharpur during Ashadhi Ekadashi is a grand spectacle. Pilgrims from across Maharashtra unite in devotion. The palkhi tradition reflects Maharashtra’s spiritual and cultural unity. Pandharpur is the eternal home of the Sant Dynaneshwar Palkhi."
  },
  {
    "title": "Sant Tukaram Palkhi Stop",
    "description": "Sant Tukaram Palkhi Yatra, starting from Dehu, reaches Pandharpur with thousands of devotees walking barefoot. The palkhi of Sant Tukaram joins the Sant Dynaneshwar procession, creating a sea of faith. Pilgrims sing Tukaram’s abhangs with joy and devotion. The event fills the town with unmatched spiritual energy. The tradition has continued for centuries, uniting generations. Sant Tukaram Palkhi Stop is Pandharpur’s celebration of collective bhakti."
  }
],


      "services": [
    {
      "name": "Pune to Pandharpur Cab Booking",
      "description": "Book your cab from Pune to Pandharpur with ease and confidence through our reliable service. Whether you're traveling solo, with family, or in a group, our fleet of well-maintained vehicles and professional drivers ensure a safe and comfortable journey. Flexible booking options, including online reservations and instant confirmations, make planning your pilgrimage or leisure trip hassle-free. Enjoy punctual pickups, transparent pricing, and customer-centric service to make your travel experience smooth and memorable."
    },
    {
      "name": "AC Taxi Pandharpur Trip",
      "description": "Travel comfortably on your Pune to Pandharpur pilgrimage or leisure trip with our air-conditioned taxi service. These vehicles provide a refreshing atmosphere during long journeys, helping you stay cool and relaxed. Equipped with plush interiors and smooth rides, our AC taxis are ideal for families, senior citizens, and corporate travelers. Professional drivers ensure timely pickups and safe driving, enhancing your overall travel experience to this spiritual destination."
    },
    {
      "name": "Round Trip Pandharpur Cab",
      "description": "Explore Pandharpur and return to Pune with our flexible round trip cab service. This option offers the convenience of scheduled pickups and drop-offs tailored to your itinerary, allowing you to visit temples, local attractions, and markets at your own pace. Our vehicles are spacious and comfortable, and our drivers experienced with the pilgrimage route, ensuring safety and timely service throughout your journey."
    },
    {
      "name": "One Way Pandharpur Taxi",
      "description": "Our one way taxi service from Pune to Pandharpur is perfect for travelers with onward plans or differing drop-off points. Offering transparent fares and reliable service, you can book a cab without committing to a return trip. All vehicles are regularly serviced and operated by courteous drivers who prioritize your safety and punctuality, making your journey straightforward and stress-free."
    },
    {
      "name": "Budget Cab Pune to Pandharpur",
      "description": "For those looking to travel economically, our budget cab service from Pune to Pandharpur provides safe and reliable transportation without unnecessary extras. Ideal for pilgrims, students, or solo travelers, these vehicles offer basic amenities and clean interiors. Benefit from affordable pricing, transparent fare structures, and drivers committed to ensuring a smooth journey at a value-for-money cost."
    },
    {
      "name": "SUV Cab for Pilgrimage",
      "description": "Travel in style and comfort with our premium SUV cab service designed for pilgrimage trips to Pandharpur. These spacious vehicles provide ample room for families and groups, along with superior road handling and suspension to navigate varied terrain comfortably. Equipped with modern amenities and driven by experienced chauffeurs, our SUVs ensure a dignified and safe pilgrimage experience."
    },
    {
      "name": "Family Pandharpur Taxi Hire",
      "description": "Make your family pilgrimage to Pandharpur comfortable and convenient with our dedicated family taxi hire service. Spacious vehicles, equipped with safety features and ample luggage space, accommodate all family members including elders and children. Our friendly drivers assist with stops and luggage handling, ensuring a stress-free and enjoyable journey tailored to your family’s needs."
    },
    {
      "name": "Group Cab Pandharpur",
      "description": "Ideal for groups traveling together, our group cab service to Pandharpur provides comfortable and affordable transportation with vehicles suited to larger parties. Whether it's a religious group, friends on a trip, or colleagues attending an event, our fleet includes multi-seater vehicles driven by professional drivers experienced with group logistics and routes, ensuring timely pickups and drop-offs."
    },
    {
      "name": "Corporate Pilgrimage Taxi",
      "description": "Our corporate pilgrimage taxi service caters to companies and organizations arranging trips to Pandharpur for employees or clients. Offering punctual, discreet, and professional transportation with a variety of vehicle options including AC sedans and SUVs, we ensure your corporate group travels comfortably and efficiently. Flexible billing and long-term contracts are available to suit business needs."
    },
    {
      "name": "Online Pandharpur Cab Booking",
      "description": "Book your Pune to Pandharpur cab easily online through our secure platform. Select your vehicle, choose your travel dates, and get instant confirmation along with clear fare details. Our platform offers 24/7 customer support, allowing you to modify or cancel bookings with ease, making your pilgrimage planning seamless and stress-free."
    },
    {
      "name": "Pandharpur Temple Taxi Fare",
      "description": "Get transparent and competitive fare estimates for your taxi travel to Pandharpur temples. Our pricing includes taxes, tolls, and driver allowances with no hidden charges, helping you plan your pilgrimage budget accurately. Whether you need a single trip or a package including temple stops, our fare options are designed to provide value without compromising service quality."
    },
    {
      "name": "Private Cab Pune to Pandharpur",
      "description": "Enjoy the convenience and privacy of our exclusive private cab service from Pune to Pandharpur. Perfect for personalized travel, this service offers door-to-door pick-up and drop-off, customizable routes, and flexible scheduling. Ideal for families, groups, or individual travelers who value comfort and discretion, our private cabs come with professional drivers dedicated to providing a safe and pleasant journey."
    },
    {
      "name": "24×7 Taxi Service Pandharpur",
      "description": "Our 24×7 taxi service ensures you have reliable transportation to and from Pandharpur at any hour. Whether it’s an early morning departure or a late-night return, our fleet and drivers are available around the clock to accommodate your schedule. With prompt response times, well-maintained vehicles, and courteous drivers, this service is designed to provide peace of mind for all your travel needs."
    }
  ],
  "tableData": [
    ["Pune to Pandharpur Cab Booking", "AC Taxi Pandharpur Trip"],
    ["Round Trip Pandharpur Cab", "One Way Pandharpur Taxi"],
    ["Budget Cab Pune to Pandharpur", "SUV Cab for Pilgrimage"],
    ["Family Pandharpur Taxi Hire", "Group Cab Pandharpur"],
    ["Corporate Pilgrimage Taxi", "Online Pandharpur Cab Booking"],
    ["Pandharpur Temple Taxi Fare", "Private Cab Pune to Pandharpur"],
    ["24×7 Taxi Service Pandharpur"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Pandharpur Taxi",
    "WhyChoosedescription": "Vaishnavi Travels provides reliable and comfortable taxi services from Pune to Pandharpur, ideal for pilgrimage trips, family travel, and group journeys."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Choices",
    "WhyChoosedescription": "Select from Swift Dzire, Ertiga, Innova, Urbania, and Tempo Traveller to suit your group size and comfort preferences."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "Our taxis are regularly serviced and thoroughly cleaned to ensure your safety and hygiene during the trip."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with the Route",
    "WhyChoosedescription": "Our skilled drivers know the best routes between Pune and Pandharpur to provide a smooth and timely travel experience."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "We offer all-inclusive pricing covering fuel, tolls, parking, and driver allowance with no hidden charges."
  },
  {
    "WhyChooseheading": "Flexible Pickup and Drop-off Locations",
    "WhyChoosedescription": "Enjoy convenient door-to-door service from your home, hotel, or office in Pune and drop-off at your preferred destination in Pandharpur."
  },
  {
    "WhyChooseheading": "Ideal for Pilgrimage and Group Travel",
    "WhyChoosedescription": "Perfect for devotees, families, and groups looking to visit the holy town of Pandharpur comfortably."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Hassle-Free Booking",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to assist you with bookings, itinerary planning, and travel inquiries."
  }
]



















  }




const faqData = [
  [
    {
      question: 'What is the approximate distance & travel time from Pune to Pandharpur by taxi?',
      answer: 'The distance is around **205‑212 km** and the travel time is approximately **4 to 5 hours**, depending on traffic and route. :contentReference[oaicite:0]{index=0}',
    },
    {
      question: 'What types of cabs are available for the Pune to Pandharpur route?',
      answer: 'You can choose from hatchbacks (Indica, Swift etc.), sedans (Dzire, Etios etc.), SUVs (Innova, Ertiga etc.). :contentReference[oaicite:1]{index=1}',
    },
    {
      question: 'What is the typical one‑way fare from Pune to Pandharpur?',
      answer: 'Fares generally start from ~ **₹3,000‑₹3,500** for sedan cars, ~ **₹4,400‑₹4,900** for SUVs. Lower fares may be possible for hatchbacks. :contentReference[oaicite:2]{index=2}',
    },
    {
      question: 'Are there any fixed fare cab services for this route?',
      answer: 'Yes — some services like OneWayCab, Payal Cab etc. offer fixed fares (including tolls) for Pune→Pandharpur. :contentReference[oaicite:3]{index=3}',
    },
    {
      question: 'What about extras — tolls, driver allowance, night charges — are they included?',
      answer: 'Often the quoted fare includes tolls, but driver allowance, night charges, parking etc. are sometimes extra. Always confirm with the taxi provider. :contentReference[oaicite:4]{index=4}',
    },
    {
      question: 'Can I hire for round trip or return same day?',
      answer: 'Yes — many companies offer round‑trip or return packages; fares will be higher depending on return distance and wait time. :contentReference[oaicite:5]{index=5}',
    },
    {
      question: 'How far in advance should I book Pune to Pandharpur taxi?',
      answer: 'It’s safer to book at least a day ahead, especially on weekends or during festival times when demand is higher. ',
    }
  ]
];

const testimonials = [
  {
    name: "Ms. Shweta Rao",
    position: "Pilgrim Traveller",
    feedback: "Took a sedan from Pune to Pandharpur. The cab arrived on time, driver was courteous and the ride was smooth. The fare matched what was quoted. Overall hassle‑free journey.",
    rating: 5,
  },
  {
    name: "Mr. Sunil Patil",
    position: "Family Trip",
    feedback: "Chose an SUV for more comfort. Good legroom, AC worked well, and driver paused when we wanted food. Though a bit costlier, the value was worth it. Will use again.",
    rating: 4,
    style: "style-2",
  }
];













































































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];

const pandharpurTaxiSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune to Pandharpur Taxi Service",
  "description": "Reliable AC and Non-AC taxi service from Pune to Pandharpur for round trips, one-way journeys, family and corporate travel, and pilgrimage trips. Book online 24/7 with affordable fares.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Vaishnavi Travels",
    "telephone": "+91-9765685295",
    "url": "https://vaishnavitravel.com/pune-to-pandharpur-taxi"
  },
  "areaServed": [
    {
      "@type": "City",
      "name": "Pune"
    },
    {
      "@type": "City",
      "name": "Pandharpur"
    }
  ],
  "availability": "https://schema.org/InStock",
  "priceCurrency": "INR",
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Pandharpur Taxi Service Offers",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Round Trip Taxi Pune to Pandharpur"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "One Way Taxi Pune to Pandharpur"
        }
      }
    ]
  }
};





  return (
    <div>
<Helmet>
  <title>Pune to Pandharpur Taxi | AC & Budget Taxi Service</title>
  <meta
    name="description"
    content="Reliable AC and Non-AC taxi service from Pune to Pandharpur for round trips, one-way journeys, family and corporate travel, and pilgrimage trips. Book online 24/7 with affordable fares."
  />
  <meta
    name="keywords"
    content="Pune to Pandharpur Cab Booking, AC Taxi Pandharpur Trip, Round Trip Pandharpur Cab, One Way Pandharpur Taxi, Budget Cab Pune to Pandharpur, SUV Cab for Pilgrimage, Family Pandharpur Taxi Hire, Group Cab Pandharpur, Corporate Pilgrimage Taxi, Online Pandharpur Cab Booking, Pandharpur Temple Taxi Fare, Private Cab Pune to Pandharpur, 24×7 Taxi Service Pandharpur"
  />
  <script type="application/ld+json">
    {JSON.stringify(pandharpurTaxiSchema)}
  </script>
</Helmet>


      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/64.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetopansharpurtaxi;